define 'controller/LoginButtonController', ['jquery'], ($) ->
  class LoginButtonController

    constructor: (@$el) ->
      @_replaceHref()

      $('.account-navigation-layer').on 'show', -> this._replaceHref()

    _replaceHref: ->
      newurl = '/login?redirect=/customer'

      $('#account-navigation-layer__btn').attr('href', newurl)
